import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { DialogData } from 'src/app/entities/dialogData';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  text: string;
  emitter: EventEmitter;
  obj: any;
  action: any;
  showComment: false;
  processes = []
  comment: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public sharedService: SharedService) {
    this.text = data['text'];
    this.obj = data['obj'];
    this.action = data['action'];
    this.showComment = data['showComment'] || false;
  }

  ngOnInit() {

  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
  onConfirmClick(): void {

    if (['DEACTIVATE', 'ACTIVATE'].includes(this.action)) {
      this.dialogRef.close(true);
    }
    else if (this.action === 'DELETE_PROCESS') {
      this.sharedService.deleteForm(this.obj, this.comment)
      this.dialogRef.close(true);
    }
    else if (this.action === 'DELETE_DISTRICT') {
      this.sharedService.deleteDistrict(this.obj)
      this.dialogRef.close(true);
    }
    else if (this.action === 'DELETE_ILOT') {
      this.sharedService.deleteILot(this.obj)
      this.dialogRef.close(true);
    }
    else if (this.action == "CONFIRM") {
      this.sharedService.confirmDialogAction(this.obj, this.comment)
      this.dialogRef.close(false);
    }
    else if (this.action === "CONFIRM_ARCHIVE") {
      this.dialogRef.close(true);
    }
    else if (this.action === "CONFIRM_REVIVE") {
      this.dialogRef.close(true);
    }
    else if (this.action == "CONFIRM_SMS") {
      this.dialogRef.close(true);
    }
    else if (['APPROVED', 'REJECTED'].includes(this.action)) {
      this.sharedService.confirmDialogAction(this.obj);
      this.dialogRef.close(true);
    }
    else {
      this.sharedService.updateEntity(this.obj)
      this.dialogRef.close(true);
    }

  }

}